var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('linked-draggable',{attrs:{"disabled":_vm.disabled,"selected":_vm.members,"options":_vm.agents},on:{"add":_vm.addTeamMember,"remove":_vm.removeTeamMember},scopedSlots:_vm._u([{key:"default",fn:function({item}){return [_c('agent-card',{staticClass:"cursor-grabbable",attrs:{"agent":item}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }